/**
 * Safe array access utilities to handle TypeScript's noUncheckedIndexedAccess
 */

/**
 * Safely access an array index, throwing an error if the index is out of bounds
 */
export function getAtIndex<T>(array: T[], index: number): T {
  const item = array[index];
  if (item === undefined) {
    throw new Error(`Array index ${index} is out of bounds (array length: ${array.length})`);
  }
  return item;
}

/**
 * Get the first element of an array, throwing an error if empty
 */
export function firstOrThrow<T>(array: T[], errorMessage?: string): T {
  const first = array[0];
  if (first === undefined) {
    throw new Error(errorMessage ?? 'Cannot get first element of empty array');
  }
  return first;
}

/**
 * Get the first element of an array with a default fallback
 */
export function firstOr<T>(array: T[], defaultValue: T): T {
  return array[0] ?? defaultValue;
}

/**
 * Get the last element of an array, throwing an error if empty
 */
export function lastOrThrow<T>(array: T[], errorMessage?: string): T {
  const last = array.at(-1);
  if (last === undefined) {
    throw new Error(errorMessage ?? 'Cannot get last element of empty array');
  }
  return last;
}

/**
 * Get the last element of an array with a default fallback
 */
export function lastOr<T>(array: T[], defaultValue: T): T {
  return array.at(-1) ?? defaultValue;
}
